module.exports = __webpack_public_path__ + "img/Wp_2054.4dd670eb.png";